import { configureStore } from "@reduxjs/toolkit";
import msgNotificationReducer from "../features/msgNotification/msgNotificationSlice";
import balanceReducer from "../features/balance/balanceSlice";
import paymentReducer from "../features/upcomingPayment/upcomingPaymentSlice";
import savingCardReducer from "../features/savingCard/savingCardSlice";
import beneficiariesReducer from "../features/beneficiaries/beneficiariesSlice";
import recentTransactionsReducer from "../features/recentTransactions/recentTransactionSlice";
import favCreditCardReducer from "../features/favCreditCard/favCreditCardSlice";

export const store = configureStore({
  reducer: {
    msgNotification: msgNotificationReducer,
    balance: balanceReducer,
    payment: paymentReducer,
    savingCard: savingCardReducer,
    beneficiaries: beneficiariesReducer,
    recentTransactions: recentTransactionsReducer,
    favCreditCard: favCreditCardReducer,
  },
});
